import { initGeneratePage } from './generate/generate-page-handlers';

initGeneratePage();
